'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertWarning = require('./components/AlertWarning.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlertWarning).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/warning/index.js
// module id = 882
// module chunks = 0 3